<script setup lang="ts">
definePageMeta({
    layout: 'no-header-or-footer',
});

const route = useRoute();
const { locale } = useI18n();

const { tiptappAd } = await useTiptappAd(route.params.adId as string, locale);

const story = await useAsyncStoryblok('global/fb-campaign', {
    version: route.query._storyblok ? 'draft' : 'published',
    resolve_links: 'url',
    language: locale.value,
});

// Find the ad-campaign blok in the story
const adCampaign = story.value.content.global.find((blok: any) => blok.component === 'ad-campaign');

let { meta: metatags } = await useDefaultMetatags(story, locale);

metatags = {
    ...metatags,
    ogImage: tiptappAd.value?.imageUrls[0] || metatags.ogImage,
    twitterImage: tiptappAd.value?.imageUrls[0] || metatags.twitterImage,
};

if (adCampaign && tiptappAd.value) {
    // Set the correct adId so it can be used in the ad-campaign component if necessary
    adCampaign.adId = route.params.adId || adCampaign.adId;

    // Update the metatags based on the ad type
    switch (tiptappAd.value?.type) {
        case 'giaw': {
            if (adCampaign.giawPageTitle) {
                metatags.title = replaceTags(adCampaign.giawPageTitle, tiptappAd.value);
            }
            if (adCampaign.giawOgTitle) {
                metatags.ogTitle = replaceTags(adCampaign.giawOgTitle, tiptappAd.value);
            }
            if (adCampaign.giawOgDescription) {
                metatags.ogDescription = replaceTags(adCampaign.giawOgDescription, tiptappAd.value);
            }
            break;
        }
        case 'h2t': {
            if (adCampaign.h2tPageTitle) {
                metatags.title = replaceTags(adCampaign.h2tPageTitle, tiptappAd.value);
            }
            if (adCampaign.h2tOgTitle) {
                metatags.ogTitle = replaceTags(adCampaign.h2tOgTitle, tiptappAd.value);
            }
            if (adCampaign.h2tOgDescription) {
                metatags.ogDescription = replaceTags(adCampaign.h2tOgDescription, tiptappAd.value);
            }
            break;
        }
        case 'paaw': {
            if (adCampaign.paaPagewTitle) {
                metatags.title = replaceTags(adCampaign.paawPageTitle, tiptappAd.value);
            }
            if (adCampaign.paawOgTitle) {
                metatags.ogTitle = replaceTags(adCampaign.paawOgTitle, tiptappAd.value);
            }
            if (adCampaign.paawOgDescription) {
                metatags.ogDescription = replaceTags(adCampaign.paawOgDescription, tiptappAd.value);
            }
            break;
        }
    }
}

useServerSeoMeta(metatags);

function replaceTags(template: string, tiptappAd: TiptappAd) {
    return template
        .replaceAll('{{adTitle}}', tiptappAd.title || '')
        .replaceAll('{{completedIn}}', tiptappAd.completedIn || '');
}
</script>

<template>
    <StoryblokComponent
        v-if="story"
        :blok="{ ...story.content, published_at: story.published_at, created_at: story.created_at }"
    />
</template>
